import config from './config.js'

/**
 * Get order id in url parameter
 */
// preload the loading image
const imgUrl = 'https://prod-cms-bucket.s3.amazonaws.com/76278d769b9f43aa82c3fa6e22e1dd05.png'
let preloadImg = new Image()
preloadImg.src = imgUrl

export const loadFonts = () => {
    // prconnect to CDN
    appendFile('preconnect', 'anonymous', 'https://cms-assets.parcelperform.com')

    // preload fonts
    const urls = ['https://cms-assets.parcelperform.com/ab42da5cd54f4fd0a635877cf8406628.ttf', 'https://cms-assets.parcelperform.com/dc2866a7e1844a0498a203979c777f4d.ttf']
    urls.forEach(url => {
        appendFile('preload', 'anonymous', url, 'font')
    })
}

const appendFile = (rel, crossorigin, url, type) => {
    const head = document.getElementsByTagName('head')[0]
    let link = document.createElement('link')
    link.rel = rel
    link.crossorigin = crossorigin
    link.href = url
    if (type) {
        link.as = type
    }
    head.appendChild(link)
}

export const urlOrderId = () => {
    const queryParams = location.search
        .slice(1)
        .split('&')
        .map(p => p.split('='))
        .reduce((obj, pair) => {
            const [key, value] = pair.map(decodeURIComponent)
            return ({ ...obj, [key.toLowerCase()]: value })
        }, {})

    // No order id founded in URL or wrong format
    if (!queryParams.orderid || queryParams.orderid === '' && queryParams.orderid === 'true') {
        return null
    }

    return queryParams.orderid || null
}

/**
 * Search order id in HTML
 * return Int Order ID or 0 for order in Pending status
 */
export const findOrderId = () => {
    let orderFromFirstRow
    if (document.querySelector('.my-orders-list__cell.my-orders-list__order .my-orders-list__cell--description')) {
        orderFromFirstRow = parseInt(document.querySelector('.my-orders-list__cell.my-orders-list__order .my-orders-list__cell--description').innerText)
        // The order number can be a text before it's proceed by Nespresso
        if (!orderFromFirstRow && typeof document.querySelector('.my-orders-list__cell.my-orders-list__order .my-orders-list__cell--description').innerText === 'string') {
            return 0
        }
    } else if (document.querySelector('#myaccount-orders #my-order-line1 td:nth-child(5)')) {
        orderFromFirstRow = parseInt(document.querySelector('#myaccount-orders #my-order-line1 td:nth-child(5)').innerText)
    }

    if (isNaN(orderFromFirstRow)) {
        return null
    }

    return orderFromFirstRow || null
}

/**
 * Load an order
 * API call to e.g. https://nestle-epr.apimanagement.hana.ondemand.com/Nespresso/Order/GetOrderStatus?EntID=7&OrdID=35207147
 * Return plain text but it's a JSON
 */
export const getAPIUrl = orderId => {
    const formattedOrderId = `${window.trackTrace.market.orderNumberPrefix}${orderId}${window.trackTrace.market.orderNumberSuffix}`
    return `${config.orderApi.host}?EntID=${window.trackTrace.market.id}&OrdID=${formattedOrderId}`
}

export const fetchAsync = async url => {
    return await (await fetch(url)).json()
}

export const loadWidget = (slug, orderId) => {
    const widget = document.createElement('div')
    widget.setAttribute('id', 'pp-widget-root')
    widget.setAttribute('data-cms-slug', slug)
    widget.setAttribute('data-order-id', orderId)
    widget.style.maxWidth = '996px'
    widget.style.margin = '0 auto'
    return widget
}

export const loadForm = (translations, errorMode = false) => {
    const form = document.createElement('form')
    form.innerHTML = `
    <style>
        form {
            position: relative;
            z-index: 1
        }
        form.svelte-1kfqxtf {
            text-align: center;
            padding: 32px 16px;
            min-width: 300px;
            max-width: 664px;
            width: 50%;
            margin: 0 auto;
            color: #9c9c9c
        }

        input.svelte-1kfqxtf {
            margin-bottom: 1em;
            width: 100%;
            border: 1px solid #cccccc;
            font-size: 12px
        }

        input.svelte-1kfqxtf::-moz-placeholder {
            color: initial
        }

        input.svelte-1kfqxtf::-webkit-input-placeholder {
            color: initial
         }

        button.svelte-1kfqxtf {
            text-transform: uppercase;
            width: 100%
        }

        .tracker-header.svelte-qf1iy2 {
            padding: 0 20px
        }

        h1.svelte-qf1iy2 {
            font-size: 36px;
            line-height: 48px;
            margin-bottom: 24px;
            text-transform: uppercase;
            border-bottom: 1px solid #e6e6e6;
            padding-bottom: 8px;
            text-align: center
        }

        h3.svelte-qf1iy2 {
            font-size: 18px;
            margin-bottom: 26px;
            text-transform: uppercase
        }

        p.svelte-qf1iy2 {
            margin-bottom: 24px;
            text-align: center;
        }

        small.svelte-qf1iy2 {
            font-weight: 400
        }

        .alignCenter.svelte-qf1iy2 {
            text-align: center
        }

        .g .headline {
            font-size: 12px;
            margin-bottom: 8px
        }

        strong {
            text-transform: uppercase
        }

        @media screen and (max-width: 995px) {
            .tracker-header.svelte-qf1iy2 {
                padding: 32px 16px 0 32px
            }

            p.svelte-qf1iy2 {
                margin-bottom: 24px;
            }
        }

        .tracker.svelte-1l5v8mu.svelte-1l5v8mu {
            padding: 32px 16px;
            background: white;
            color: black
        }

        .tracker.svelte-1l5v8mu .svelte-1l5v8mu {
            box-sizing: border-box
        }

        .g_restrict.svelte-1l5v8mu.svelte-1l5v8mu {
            display: table;
            position: relative;
            width: 100%;
            height: 100%;
            max-width: 46.25em;
            padding: 0 2em;
            margin: 0 auto
        }

        @media screen and (max-width: 995px) {
            .tracker.svelte-1l5v8mu.svelte-1l5v8mu {
                padding: 0
            }

            .tracker-body.svelte-1l5v8mu.svelte-1l5v8mu {
                padding: 32px 16px
            }

            .g_restrict.svelte-1l5v8mu.svelte-1l5v8mu {
                padding: 0
            }
        }
        .tracker.svelte-1l5v8mu.svelte-1l5v8mu{padding:32px 16px;background:white;color:black}.tracker.svelte-1l5v8mu .svelte-1l5v8mu{box-sizing:border-box}.g_restrict.svelte-1l5v8mu.svelte-1l5v8mu{display:table;position:relative;width:100%;height:100%;max-width:46.25em;padding:0 2em;margin:0 auto}@media screen and (max-width: 995px){.tracker.svelte-1l5v8mu.svelte-1l5v8mu{padding:0}.tracker-body.svelte-1l5v8mu.svelte-1l5v8mu{padding:32px 16px}.g_restrict.svelte-1l5v8mu.svelte-1l5v8mu{padding:0}}
        .tracker-error{padding:0 40px;position:relative;color:#D98600;text-align:justify;margin:32px auto 40px;max-width:80%}.tracker-error > svg{position:absolute;left:10px;top:0;width:20px;height:20px}

        #js-tooltip-block{padding: 12px 0 12px;}
    </style>
    <div class="g tracker svelte-1l5v8mu">
        <div class="g_restrict svelte-1l5v8mu">
            <div class="tracker-header svelte-qf1iy2" style=""><h1 class="svelte-qf1iy2">${translations.title}</h1>
            ${translations.orderInfoLabel ? `<p class="svelte-qf1iy2">${translations.orderInfoLabel}</p>` : ''}
            </div>
            <form class="svelte-1kfqxtf" action="_self" method="get">
            <input required="" autofocus="" placeholder="${translations.orderId}" type="search"
                                                         id="trackerOrderInput"
                                                         class="TextField__input TextField__input--compact svelte-1kfqxtf"
                                                         name="orderId"
                                                         maxlength="10"
                                                         pattern="[0-9]+">
                <button type="submit" class="ElementWithChevron DefaultButton DefaultButton--regular svelte-1kfqxtf">
                    ${translations.submit}
                </button>
            </form>
            <div class="tracker-body svelte-1l5v8mu" style="display:${errorMode ? 'block' : 'none'}">
            <div class="tracker-error">
                <svg viewBox="0 0 36 36" width="36" height="36" xmlns="http://www.w3.org/2000/svg"
                     shape-rendering="optimizeQuality">
                    <g data-name="Group 8" transform="translate(-1221.5 1125.5)">
                        <circle data-name="Ellipse 7" cx="17.5" cy="17.5" r="17.5" transform="translate(1222 -1125)"
                                fill="#D98600"></circle>
                        <path data-name="Path 18"
                              d="M1240.856-1118l-.278 15.088h-1.978l-.263-15.088zm-1.23 21.27a1.579 1.579 0 01-1.15-.469 1.543 1.543 0 01-.476-1.143 1.567 1.567 0 01.476-1.152 1.567 1.567 0 011.15-.476 1.574 1.574 0 011.142.476 1.555 1.555 0 01.483 1.15 1.531 1.531 0 01-.483 1.145 1.587 1.587 0 01-1.142.469z"
                              fill="#fff" stroke="#fff" stroke-miterlimit="10"></path>
                    </g>
                </svg>
                ${translations.noOrderInfoMessage}
            </div>
        </div>
        </div>
    </div>`

    return form
}

export const displayInfoToolTip = (findOrderIDLabel, findOrderIDTooltip) => {
    const infoToolTipEl = document.createElement('div')
    infoToolTipEl.setAttribute('id', 'js-tooltip-block')
    document.querySelector('.tracker .g_restrict').appendChild(infoToolTipEl)

    const projectData = {
        'id': 'js-tooltip-block',
        'version': 'latest',
        'created': '',
        'preload': {
            'nb-icon': {
                'style': '/shared_res/agility/next-components/icon/v1.1/css/icon.css',
                'modern': '/shared_res/agility/next-components/icon/v1.1/index.es.min.js',
                'legacy': '/shared_res/agility/next-components/icon/v1.1/index.legacy.min.js'
            }
        },
        'components': [
            {
                'uuid': 'nb-tooltip-b28a6fc4-e4c4-239d-4ccc-7b1e1d4aa7e7',
                'module': 'nb-tooltip',
                'tag': 'nb-tooltip',
                'folder': '/shared_res/agility/next-components/tooltip/',
                'version': '1.1.1',
                'minHeight': '24',
                'minHeightMobile': '24',
                'variations': [
                    {
                        'index': 0,
                        'properties': {
                            'alignment': 'right',
                            'position': 'top',
                            'label': findOrderIDLabel,
                            'content': findOrderIDTooltip
                        },
                        'personalisation': null
                    }
                ]
            }
        ]
    }

    window.nwc = window.nwc || {}
    window.nwc.projects = window.nwc.projects || []
    window.nwc.projects.push(projectData);

    if(!window.nwc.load){
        loadNWCjs();
    }
    else{
        window.nwc.load()
    }
}

export const loadNWCjs = () => {
    (function (p, a, g, e, b, u, i, l, d, r) {
        p[b] = p[b] || {}
        if (p[b].loading) {return} else if (p[b].loaded) {
            p[b].ready()
            return
        }
        p[b].loading = 1
        p[b].ready = function () {
            p[b].loading = 0
            p[b].loaded = 1
            p[b].load()
        }
        u = a.createElement(g)
        i = a.getElementsByTagName(g)[0]
        u.async = 1
        u.src = e
        u.onload = p[b].ready
        i.parentNode.insertBefore(u, i)
    })(window, document, 'script', '/shared_res/agility/page-builder/assets/js/nwc.min.js', 'nwc')
}

export const displayLoader = () => {
    const loaderWrapper = document.createElement('div')
    loaderWrapper.setAttribute('id', 'trackHqLoader')
    loaderWrapper.innerHTML = `
        <style type="text/css">
            div[data-cms-slug] {
                position: relative;
                z-index:1;
            }
            .g_loader-ele {
                width: 400px;
                height: 250px;
                display: flex;
                flex-direction: column;
                -webkit-box-align: center;
                align-items: center;
                -webkit-box-pack: center;
                justify-content: center;
                line-height: normal;
                padding: 0px 10px;
                position: absolute;
                top: 8px;
                background: #fff;
                left: 50%;
                margin-left: -200px;
                z-index:0;
            }
        </style>
        <div class="g_loader-ele">
            <img src="${imgUrl}" alt="loading" />
        <div>
    `
    document.querySelector('.my-order-details').appendChild(loaderWrapper)
}

export const removeLoader = () => {
    const ele = document.getElementById('trackHqLoader')
    if (ele)
        ele.remove()
}

export const replaceContainer = (iframe, options) => {
    const frag = document.createDocumentFragment()
    frag.appendChild(iframe)

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (width < 996 && options) {
        const target = document.querySelector('.my-orders-list__more-orders')
        if (!target || !target.parentNode) {
            return
        }

        target.parentNode.insertBefore(frag, target.nextSibling)
    } else {
        const target = document.querySelector('.my-order-details')
        if (!target) {
            return
        }

        target.insertBefore(frag, target.firstChild)
    }
}

export const loadScript = url => {
    var s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.defer = true
    s.src = url
    var x = document.getElementsByTagName('head')[0]
    x.appendChild(s)
}

export const getSlug = (translations, market, lang) => {
    let slug = config.ppApi.slugs.default

    if (translations.slug) {
        slug = translations.slug
    } else
        if (config.ppApi.slugs[market] && config.ppApi.slugs[market][lang]) {
            slug = config.ppApi.slugs[market][lang]
        }

    return slug
}
